






































import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { format, parse, isValid, getNow } from "@/lib/time";
import { InputMaskOptions } from "@/modules/inputMask";
import { INPUT_PROPS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";

export default defineComponent({
  name: "BaseInputDate",
  components: { BaseInput, BaseIcon },
  props: {
    ...INPUT_PROPS,
    dateFormat: { type: String, default: "MM/dd/yyyy" },
    min: { type: [Date, String] },
    max: { type: [Date, String] },
  },
  setup(props, { emit }) {
    const inputElement = ref<HTMLInputElement>();
    const support = ref(true);

    const minValue = computed(() => {
      const date = props.min ? new Date(props.min) : getNow();
      if (!support.value) return format(date, props.dateFormat);
      return format(date, "yyyy-MM-dd");
    });
    const maxValue = computed(() => {
      const date = props.max ? new Date() : new Date(getNow().setFullYear(getNow().getFullYear() + 1));
      if (!support.value) return format(date, props.dateFormat);
      return format(date, "yyyy-MM-dd");
    });
    const inputFormat = computed(() => props.dateFormat.toLowerCase());
    const datePlaceholder = computed(() => inputFormat.value.toUpperCase());
    const opts = computed<InputMaskOptions>(() => ({
      alias: "datetime",
      inputmode: "numeric",
      inputFormat: inputFormat.value,
      placeholder: datePlaceholder.value,
      min: minValue.value,
      max: maxValue.value,
    }));
    const currentValue = computed(() => {
      if (/\d{4}-\d{2}-\d{2}/.test(props.value ?? "")) {
        const date = new Date(props.value ?? "");
        return format(date, props.dateFormat.replace("/", ""));
      }
      return props.value;
    });

    const onInput = (v: string) => {
      const date = parse(v, props.dateFormat, getNow());
      if (isValid(date)) {
        emit("input", format(date, "yyyy-MM-dd"));
      } else emit("input", v);
    };

    onMounted(() => {
      support.value = inputElement.value?.type === "date";
    });

    return {
      minValue,
      maxValue,
      opts,
      support,
      currentValue,
      datePlaceholder,
      inputElement,
      onInput,
    };
  },
});
